<template>
  <b-container>
    <b-row>
      <b-col>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>

export default {
  name: "SinglePost",
}
</script>

<style scoped>

</style>